import React, { useState, useEffect } from 'react';
import { Box, Grid, IconButton, Modal } from '@material-ui/core';
import ZoomIn from '@material-ui/icons/ZoomIn';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Cancel from '@material-ui/icons/Cancel';
import { auth_fetch } from 'utils/ajax';
import { checkSuccess } from 'utils/ajax';
import { TileInCellFilterSet } from 'models/BackendModels';
import config from 'config';


export const fetchTilesInCellFilterSet = (
  cellFilterSetId: number,
): Promise<TileInCellFilterSet[]> =>
  auth_fetch(`${config.backend}/api/wsis_in_cell_filtersets/${cellFilterSetId}/`, {
      method: 'GET',
  }).then(checkSuccess);


export const updateTileUsability = (
  wsiInCellFilterSetId: number,
  isUsable: boolean,
): Promise<void> =>
  auth_fetch(`${config.backend}/api/wsi_in_cell_filterset/${wsiInCellFilterSetId}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      isUsable: isUsable,
    }),
  }).then(checkSuccess);

export const TileSelection: React.FC = () => {
  const [tiles, setTiles] = useState<TileInCellFilterSet[]>([]);
  const [zoomedTile, setZoomedTile] = useState<string | null>(null);

  useEffect(() => {
    // Fetch tiles from backend
    const fetchTiles = async () => {
      try {
        const response = await fetchTilesInCellFilterSet(4);
        setTiles(response);
      } catch (error) {
        console.error('Error fetching tiles:', error);
      }
    };

    fetchTiles();
  }, []);

  const toggleTileUsability = async (tileId: number) => {
    try {
      const updatedTiles = tiles.map(tile => {
        if (tile.id === tileId) {
          return { ...tile, isUsable: !tile.isUsable };
        }
        return tile;
      });
      setTiles(updatedTiles);

      // Update backend
      await updateTileUsability(tileId, updatedTiles.find(t => t.id === tileId)?.isUsable ?? true);
    } catch (error) {
      console.error('Error updating tile:', error);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        {tiles.map((tile) => (
          <Grid item key={tile.id} xs={12} sm={6} md={4} lg={3}>
            <Box
              sx={{
                position: 'relative',
                border: '1px solid #ccc',
                borderRadius: 1,
                overflow: 'hidden',
              }}
            >
              <img
                src={tile.wsi.webUrl}
                alt={`Tile ${tile.id}`}
                style={{
                  width: '100%',
                  height: '200px',
                  objectFit: 'cover',
                }}
              />
              <Box
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  padding: 1,
                  display: 'flex', 
                  columnGap: 1,
                }}
              >
                <IconButton
                  size="small"
                  onClick={() => setZoomedTile(tile.wsi.webUrl)}
                  style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
                >
                  <ZoomIn />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => toggleTileUsability(tile.id)}
                  style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
                >
                  {tile.isUsable ? (
                    <CheckCircle color="primary" />
                  ) : (
                    <Cancel color="error" />
                  )}
                </IconButton>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Zoom Modal */}
      <Modal
        open={Boolean(zoomedTile)}
        onClose={() => setZoomedTile(null)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          style={{
            maxWidth: '90vw',
            maxHeight: '90vh',
            backgroundColor: 'background.paper',
            padding: 2,
          }}
        >
          {zoomedTile && (
            <img
              src={zoomedTile}
              alt="Zoomed tile"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          )}
        </Box>
      </Modal>
    </Box>
  );
};
